import firebase from 'firebase/app'
import 'firebase/firestore'
// var alphabet = [
//   'A','B','C','D','E','F',
//   'G','H','I','J','K','L',
//   'M','N','O','P','Q','R',
//   'S','T','U','V','W','X',
//   'Y','Z',
//   'a','b','c','d','e','f',
//   'g','h','i','j','k','l',
//   'm','n','o','p','q','r',
//   's','t','u','v','w','x',
//   'y','z',
//   '1','2','3','4','5',
//   '6','7','8','9','0',
//   '.',',',':','-'
// ]
// var shift = 37
// function decrypt(data){
//   let reverse_shift = (alphabet.length - shift) % alphabet.length
//   return [... data].map(char =>
//     setChar(char, reverse_shift)).join('')
// }
// function setChar(char, shift){
//   let include = alphabet.includes(char)
//   if(include){
//     let position = alphabet.indexOf(char)
//     let new_position = (position+shift) % alphabet.length
//     return alphabet[new_position]
//   } else {
//     return char
//   }
// }
var firebaseConfig = {
  apiKey: 'AIzaSyA1hioLhe3JCEvr4saSlC_X5485CjX6Bac',
  authDomain: 'github-resolution.firebaseapp.com',
  projectId: 'github-resolution',
  storageBucket: 'github-resolution.appspot.com',
  messagingSenderId: '906101500023',
  appId: '1:906101500023:web:61cfc5ff88fb6b61f7be72'
}
firebase.initializeApp(firebaseConfig)

export default firebase
